import { IResponse, get, post } from "@Lib/request";
import { path } from "./url";
import { IMoviesShortsList } from "@Types/movies";
const { newCarApiV1, newCarApiV2, newCarApiV3, newCarApiV4, newCarApiV5 } = path;

/** 欄目詳情 */
export async function fetchGetMovieDetail(params) {
  return await get(`${newCarApiV3}/movie/category/info`, params);
}

/** 影音欄目nav */
export async function fetchGetMovieNavList(params) {
  return await get(`${newCarApiV3}/movie/nav`, params);
}

/** 影音欄目nav */
export async function fetchMovieInfo(params) {
  return await get(`${newCarApiV1}/movie/pc/info`, params);
}

/** 影音点赞 */
export async function fetchMovieLike(params) {
  return await get(`${newCarApiV2}/movie/like`, params);
}

/** 影音收藏 */
export async function fetchMovieCollect(requestParams) {
  const { status, ...params } = requestParams;
  return await post(`${newCarApiV1}/favorite/${status}`, params);
}

/** 訂閱數據 */
export async function fetchSubscriberData(params) {
  return await get(`${newCarApiV1}/movie/pc/subscriberData`, params);
}

/** 热门影片 */
export async function fetchHotVideoList(params) {
  return await get(`${newCarApiV1}/movie/pc/hot`, params);
}

/** 追片時刻表 */
export async function fetchScheduleList(params) {
  return await get(`${newCarApiV5}/movie/schedule`, params);
}

/** 热门栏目 */
export async function fetchHotColumnNav(params) {
  return await get(`${newCarApiV5}/movie/columns`, params);
}

/** 编辑列表 */
export async function fetchAuthorsList(params) {
  return await get(`${newCarApiV5}/movie/authors`, params);
}

/** 热销车款 */
export async function fetchBrandSellRank(params) {
  return await get(`${newCarApiV5}/movie/hot/brands`, params);
}

/** 短影音info */
export async function fetchShortsDetail(params) {
  return await get(`${newCarApiV5}/movie/shorts/detail`, params);
}

/** 影音合集右侧列表 */
export async function fetchArticleList(params) {
  return await get(`${newCarApiV5}/article/list`, params);
}

/** 短影音列表 */
export async function fetchShortMovieList(params): Promise<IResponse<IMoviesShortsList>> {
  return await get(`${newCarApiV5}/movie/shorts/list`, params);
}

/** 车探索 - 阅读量自增 */
export async function fetchArticleMovieRead(params:any) {
  return await get(`${newCarApiV4}/common/views`, params);
}

/** 车探索 - 栏目类型 */
export async function fetchShortsColumns(params:any) {
  return await get(`${newCarApiV5}/movie/shorts/columns`, params);
}

/** 短影音详情页 - 相關車款 */
export async function fetchShortsKindsRecommend(params:any) {
  return await get(`${newCarApiV5}/kinds/article/recommend`, params);
}

/** 短影音详情页 - 相關文章 */
export async function fetchShortsArticleRecommend(params:any) {
  return await get(`${newCarApiV4}/article/recommend-by-shorts-kind-list`, params);
}